/* eslint-disable @angular-eslint/component-class-suffix */
import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavBarComponent } from '@sc/feature-fitter-navbar';
import { FitterRouterService } from '@sc/feature-fitter-path-router-system';
import { ScreenUtils } from '@sc/utils';
import { MobilePlanningFittersComponent } from '../../components';
import { PlanningResolutionView } from '../../models';

@Component({
  selector: 'sc-fitter-planning',
  styleUrls: ['./planning.container.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NavBarComponent, RouterOutlet],
  template: `
    <header>
      <sc-fitter-navbar *ngIf="showNavBar"> </sc-fitter-navbar>
    </header>
    <main id="sc-container-id" role="main">
      <router-outlet (activate)="viewActivated($event)"></router-outlet>
    </main>
  `,
})
export class PlanningContainer {
  currentView: PlanningResolutionView = 'DESKTOP';
  showNavBar = true;
  currentPage;

  constructor(private readonly router: FitterRouterService) {
    const isMobile = !ScreenUtils.isLargeDesktopResolution();
    this.currentView = isMobile ? 'MOBILE' : 'DESKTOP';
  }

  @HostListener('window:resize', ['$event'])
  redirectToFitterPageIfDesktopResolution(): void {
    const isMobile = !ScreenUtils.isLargeDesktopResolution();
    if (isMobile && this.currentView !== 'MOBILE') {
      this.router.goToPlanning();
    } else if (!isMobile && this.currentView !== 'DESKTOP') {
      this.router.goToPlanning();
    }

    this.currentView = isMobile ? 'MOBILE' : 'DESKTOP';
    this.initShowNavBar();
  }

  viewActivated(view) {
    view?.currentPageInstance?.subscribe((page) => {
      this.currentPage = page;
      this.initShowNavBar();
    });
  }

  initShowNavBar() {
    if (this.currentPage instanceof MobilePlanningFittersComponent) {
      this.showNavBar = true;
    } else {
      this.showNavBar = ScreenUtils.isLargeDesktopResolution();
    }
  }
}
